import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "t2-main" }
const _hoisted_2 = { class: "t2-content" }
const _hoisted_3 = { class: "container mar_b" }
const _hoisted_4 = { class: "t6_breadCream" }
const _hoisted_5 = { class: "t6_two_wrap" }

import { ref } from 'vue';
    import LeftMenu from './left-menu/index.vue'
    import RightCont from './right-cont/index.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

    const typeName = ref('')
    const clickEven=(val:string)=>{
        typeName.value = val
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("span", null, "首页", -1)),
          _cache[1] || (_cache[1] = _createTextVNode()),
          _cache[2] || (_cache[2] = _createElementVNode("i", null, ">", -1)),
          _cache[3] || (_cache[3] = _createTextVNode()),
          _cache[4] || (_cache[4] = _createElementVNode("span", null, "税务中心", -1)),
          _cache[5] || (_cache[5] = _createTextVNode()),
          _cache[6] || (_cache[6] = _createElementVNode("i", null, ">", -1)),
          _cache[7] || (_cache[7] = _createTextVNode()),
          _createElementVNode("span", null, _toDisplayString(typeName.value), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(LeftMenu, { onClickChild: clickEven }),
          _createVNode(RightCont, { typeName: typeName.value }, null, 8, ["typeName"])
        ])
      ])
    ])
  ]))
}
}

})